import React from "react";
import { Option, None } from "@swiggy-private/js-fp";
import { OnPayExtraParams } from "@swiggy-private/payment-types";
import { PlaceOrderData } from "@checkout-core/interfaces/Checkout";
import { TurboStripEventAction, TurboEventMeta } from "@swiggy-private/core-ui";

export interface TurboPayConfig {
    onTurboPay: (
        queryParams: string,
        extraParams?: OnPayExtraParams,
        extraArbitaryData?: PlaceOrderData["extraArbitaryData"],
    ) => void;
    uniqueId: string;
    onPaymentMethodChange: VoidFunction;
    handleViewDetailedBillClick?: VoidFunction;
    renderFallback?: boolean;
    onError: VoidFunction;
    hideEducationComms?: boolean;
    showLoader?: boolean;
    onSDKError?: VoidFunction;
    onTurboStripImpressionEvent?: TurboStripEventAction;
    onTurboStripClickEvent?: TurboStripEventAction;
    onTooltipImpressionEvent?: (campaignId: string, stripMsg?: string) => void;
    onTooltipClickEvent?: (campaignId: string, stripMsg?: string) => void;
    onTurboPayImpressionEvent?: (
        paymentMethod: string,
        billAmount: string,
        fromFallback?: boolean,
        groupName?: string,
        meta?: TurboEventMeta,
    ) => void;
    onTurboPayClickEvent?: (
        paymentMethod: string,
        billAmount: string,
        groupName?: string,
        meta?: TurboEventMeta,
    ) => void;
    onPaymentMethodChangeClickEvent?: (
        paymentMethod: string,
        billAmount: string,
        fromFallback?: boolean,
        groupName?: string,
        meta?: TurboEventMeta,
    ) => void;
    billAmountShownOnCart?: string;
    onTurboLoaded?: VoidFunction;
    clampDiscountText?: boolean;
    isTurboV2?: boolean;
    cartTotal?: string; // For fallback, we will get cart total from turbo client since GPO might have failed
}

export interface TurboPayPlaceOrderData {
    extraParams: OnPayExtraParams;
    extraArbitaryData: PlaceOrderData["extraArbitaryData"];
}

export interface ConfigContextValue {
    host: Option<string>;
    analyticsHost: Option<string>;
    paymentReturnUrl?: Option<string>;
    addMoneyReturnUrl?: Option<string>;
    addSwiggyMoneyReturnUrl?: Option<string>;
    cachePaymentData?: Option<boolean>;
    cacheGetAllCardsData?: Option<boolean>;
    enableCardRateLimit?: Option<boolean>;
    enablePublicApi?: Option<boolean>;
    turboPayConfig?: Option<TurboPayConfig>;
    turboPayPlaceOrderData?: TurboPayPlaceOrderData;
    simplPostLinkingRedirectUrl: Option<string>;
    enableConfirmOrderDifferentialOrderIdAlert?: Option<boolean>;
    isJuspayV3Enabled?: Option<boolean>;
}

export const ConfigContext = React.createContext<ConfigContextValue>({
    host: None,
    analyticsHost: None,
    simplPostLinkingRedirectUrl: None,
    enableConfirmOrderDifferentialOrderIdAlert: None,
});

if (__DEV__) {
    ConfigContext.displayName = "ConfigContext";
}
